var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("NEXD is currently in maintenance mode.")]),_c('br'),_c('h3',[_vm._v("Sorry for the inconvenience")])])
}]

export { render, staticRenderFns }